import { useState } from 'react';
import Navbar from '@/pages/home/components/Navbar';
import Footer from '@/pages/home/components/Footer';

const images = [
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/0c248c5e-97f8-44e1-92cb-486d72c6a52c_WhatsApp-Image-2026-04-15-at-10.45.15-AM.jpeg?v=ac6ae63e7f19abddc3508d2d51f162f6',
    alt: 'Quiroz Construction Cleaning Las Vegas jobsite',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/90c67349-3dd6-4fca-a2a2-e089b72f20d2_WhatsApp-Image-2026-04-15-at-10.45.15-AM-1.jpeg?v=c36075b135376ba828ea777261aa03a0',
    alt: 'Post-construction cleaning Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/0641019a-b883-40a1-8e2d-4b38cbb664de_WhatsApp-Image-2026-04-15-at-10.45.16-AM.jpeg?v=2f9aceea593b0014c72d3d0570598549',
    alt: 'Construction cleaning crew Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/acdb5876-fad3-4896-833d-7cb7bad06431_WhatsApp-Image-2026-04-15-at-10.45.16-AM-1.jpeg?v=1242f6c6f6511c8b93de9393ba5cd548',
    alt: 'Commercial cleaning Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/075c285e-62c5-4ea5-85c1-d70fb407bee4_WhatsApp-Image-2026-04-15-at-10.45.16-AM-2.jpeg?v=e023aff6d1df10f3ef505a8a7b4db368',
    alt: 'Debris removal Las Vegas construction',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/29083455-f67f-4c26-9d37-55b74d455611_WhatsApp-Image-2026-04-15-at-10.45.16-AM-3.jpeg?v=8eb0f7ec72f81b9ac26be014a8897c5b',
    alt: 'Final cleaning Las Vegas construction project',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/5ede7919-9ec1-4958-a150-1fee6077c08b_WhatsApp-Image-2026-04-15-at-10.45.16-AM-4.jpeg?v=26a4391584eb08c210fcb18e6bd8d9d7',
    alt: 'Rough cleaning Las Vegas construction site',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/24b5b8fc-e863-4a39-8b5a-e59dfbc7a420_WhatsApp-Image-2026-04-15-at-10.45.17-AM.jpeg?v=10d3f08c1dd5c610d026e6b9dcd7d363',
    alt: 'Post-construction cleaning results Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/5be66b0a-a8d5-4d92-9a14-87b61f711c95_WhatsApp-Image-2026-04-15-at-10.45.17-AM-1.jpeg?v=10abd4ed94abda1b0d595c75f90ff1bd',
    alt: 'Professional cleaning crew Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/d3941c3e-6342-4c7f-bbcd-f49558071603_WhatsApp-Image-2026-04-15-at-10.45.18-AM.jpeg?v=537bc98112cd3b646f05e5b4ec536f14',
    alt: 'Construction site cleanup Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/9aa4fb79-d364-4212-b8a9-1c230dd6a5c9_WhatsApp-Image-2026-04-15-at-10.45.18-AM-1.jpeg?v=200315535bcf169aa5f07a6aff4d0568',
    alt: 'Quiroz cleaning team in action Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/089b1012-2d0e-4e3c-bc5c-24afd294d922_WhatsApp-Image-2026-04-15-at-10.45.18-AM-2.jpeg?v=c3e11099ed542b33e6225bf5712487f7',
    alt: 'Construction cleaning Las Vegas NV',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/da2dc47c-4acd-4ae7-8749-69fe7beedd3c_WhatsApp-Image-2026-04-15-at-10.45.19-AM.jpeg?v=145f9089c5d935777f3069aafdcf0a5c',
    alt: 'Commercial cleaning services Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/a51a6da3-3fff-43ad-a98c-da22c2cd254a_WhatsApp-Image-2026-04-15-at-10.45.19-AM-1.jpeg?v=7675cae47484b45a35a561858579cf1b',
    alt: 'Post-construction dust removal Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/ad6501fd-d9ea-4ff8-a60b-7a2f80466b60_WhatsApp-Image-2026-04-15-at-10.45.19-AM-2.jpeg?v=08e468bce764bb1b3941380ec9c1bbb8',
    alt: 'Spotless construction cleaning Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/cc937740-4fdb-4d7a-8f0e-7330bc922de6_WhatsApp-Image-2026-04-15-at-10.45.19-AM-3.jpeg?v=c258473f55fb072b02adcb0009bedf68',
    alt: 'Final clean Las Vegas construction project',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/dd06041c-d2b6-40cd-a46c-bbcb5edf8b85_WhatsApp-Image-2026-04-15-at-10.45.19-AM-4.jpeg?v=91abf4fdd7d782d3b5701160cf960dd0',
    alt: 'Quiroz Construction Cleaning Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/a2091f93-9ea2-4e30-b656-8947ea509c30_WhatsApp-Image-2026-04-15-at-10.45.20-AM.jpeg?v=b0c7e1b2e8e1653711b5019e194cf9a8',
    alt: 'Move-in ready cleaning Las Vegas',
  },
  {
    src: 'https://storage.readdy-site.link/project_files/0aaf9d9e-55ec-4318-a0a2-f5b263996606/6dc7d661-9687-4875-b919-3124f7b6b71f_WhatsApp-Image-2026-04-15-at-10.45.20-AM-1.jpeg?v=b6827ee36fa0479245effa563852dc06',
    alt: 'Construction cleaning before and after Las Vegas',
  },
];

export default function Gallery() {
  const [lightbox, setLightbox] = useState<number | null>(null);

  const prev = () => setLightbox((p) => (p !== null ? (p - 1 + images.length) % images.length : null));
  const next = () => setLightbox((p) => (p !== null ? (p + 1) % images.length : null));

  return (
    <main className="bg-[#1a1a1a] min-h-screen font-inter">
      <Navbar />

      {/* Hero banner */}
      <section className="pt-32 pb-16 px-6 md:px-16 lg:px-24 text-center">
        <div className="inline-flex items-center gap-2 mb-4">
          <div className="w-8 h-px bg-[#C9A84C]"></div>
          <span className="font-inter text-[#C9A84C] text-xs tracking-widest uppercase">Our Work</span>
          <div className="w-8 h-px bg-[#C9A84C]"></div>
        </div>
        <h1 className="font-barlow-condensed font-900 text-white text-5xl md:text-7xl leading-none mb-4">
          PROJECT GALLERY
        </h1>
        <p className="font-inter text-white/50 text-sm max-w-lg mx-auto leading-relaxed">
          Real jobsite photos from post-construction and commercial cleaning projects completed by Quiroz Construction Cleaning, LLC across Las Vegas, Nevada.
        </p>
      </section>

      {/* Masonry grid */}
      <section className="px-6 md:px-16 lg:px-24 pb-24">
        <div className="columns-1 sm:columns-2 lg:columns-3 xl:columns-4 gap-4 space-y-4">
          {images.map((img, idx) => (
            <div
              key={idx}
              className="break-inside-avoid relative overflow-hidden rounded-sm cursor-pointer group"
              onClick={() => setLightbox(idx)}
            >
              <img
                src={img.src}
                alt={img.alt}
                title={img.alt}
                className="w-full h-auto object-cover transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/40 transition-all duration-300 flex items-center justify-center">
                <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-300 w-10 h-10 flex items-center justify-center bg-[#C9A84C] rounded-sm">
                  <i className="ri-zoom-in-line text-[#1a1a1a] text-lg"></i>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA strip */}
      <section className="bg-[#111111] py-16 px-6 md:px-16 lg:px-24 text-center">
        <h2 className="font-barlow-condensed font-900 text-white text-3xl md:text-4xl leading-none mb-4">
          READY FOR RESULTS LIKE THESE?
        </h2>
        <p className="font-inter text-white/50 text-sm mb-8">
          Get professional post-construction cleaning in Las Vegas — trusted by contractors and builders.
        </p>
        <a
          href="/"
          className="inline-flex items-center gap-3 bg-[#C9A84C] hover:bg-[#E8C96A] text-[#1a1a1a] font-barlow font-800 text-sm px-10 py-4 rounded-sm transition-all duration-200 cursor-pointer whitespace-nowrap tracking-widest uppercase"
        >
          Request a Quote
          <i className="ri-arrow-right-line"></i>
        </a>
      </section>

      <Footer />

      {/* Lightbox */}
      {lightbox !== null && (
        <div
          className="fixed inset-0 z-50 bg-black/95 flex items-center justify-center px-4"
          onClick={() => setLightbox(null)}
        >
          <button
            className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-white/20 rounded-sm transition-colors cursor-pointer"
            onClick={() => setLightbox(null)}
          >
            <i className="ri-close-line text-white text-xl"></i>
          </button>
          <button
            className="absolute left-4 md:left-8 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#C9A84C] rounded-sm transition-colors cursor-pointer"
            onClick={(e) => { e.stopPropagation(); prev(); }}
          >
            <i className="ri-arrow-left-line text-white text-lg"></i>
          </button>
          <div onClick={(e) => e.stopPropagation()} className="max-w-5xl max-h-[85vh] w-full flex items-center justify-center">
            <img
              src={images[lightbox].src}
              alt={images[lightbox].alt}
              className="max-w-full max-h-[85vh] object-contain rounded-sm"
            />
          </div>
          <button
            className="absolute right-4 md:right-8 w-10 h-10 flex items-center justify-center bg-white/10 hover:bg-[#C9A84C] rounded-sm transition-colors cursor-pointer"
            onClick={(e) => { e.stopPropagation(); next(); }}
          >
            <i className="ri-arrow-right-line text-white text-lg"></i>
          </button>
          <div className="absolute bottom-6 left-1/2 -translate-x-1/2 font-inter text-white/40 text-xs tracking-widest">
            {lightbox + 1} / {images.length}
          </div>
        </div>
      )}
    </main>
  );
}
